module.exports = __webpack_public_path__ + "img/banner1_768.facadb67.png";